import { CustomerType } from '../enums/customerType'

interface GetIsAddressExemptionAvailableOptions {
  customerCountry: string | null | undefined
  customerType: CustomerType | undefined
  isFrenchComplianceMode: boolean
}

export const getIsAddressExemptionAvailable = (options: GetIsAddressExemptionAvailableOptions): boolean => {
  const { customerCountry, customerType, isFrenchComplianceMode } = options

  return isFrenchComplianceMode && customerType === CustomerType.Individual && customerCountry === 'FR'
}
